import { rankingCommonConfig } from './common'
import type { RankingPageConfig } from './types'
import { resources as brandResources } from '@/config/brands'

export const theme = {
  rankGradient: 'linear-gradient(315deg, #7761F7 0%, #F992FF 100%)',
} as const

export const resources = {
  homeBg: '/images/pearla/home-bg.webp',
  spikeletL: '/images/pearla/ranking/spikelet_l.png',
  spikeletR: '/images/pearla/ranking/spikelet_r.png',
  goldMedal: brandResources.medals.goldMedal,
  silverMedal: brandResources.medals.silverMedal,
  bronze: brandResources.medals.bronze,
  medal: brandResources.medals.medal,
} as const

export const rankingConfig: RankingPageConfig = {
  theme,
  resources,
  texts: rankingCommonConfig.texts,
}
